"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var sis_portfolio_accounting_model_1 = require("./sis-portfolio-accounting-model");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var store_1 = require("@ngrx/store");
var skynet_store_currencies_api_1 = require("@synisys/skynet-store-currencies-api");
var Subject_1 = require("rxjs/Subject");
require("rxjs/add/operator/takeUntil");
var simple_filter_change_model_1 = require("../../model/simple-filter-change.model");
var SisPortfolioAccountingComponent = /** @class */ (function () {
    function SisPortfolioAccountingComponent(currentLanguageProvider, store) {
        var _this = this;
        this.currentLanguageProvider = currentLanguageProvider;
        this.store = store;
        this.messageKey = 'portfolio.filter.invalidAccounting.message';
        this.errorMessageKey = '';
        this.changedValuesToBeEmitted = new sis_portfolio_accounting_model_1.PortfolioAccountingModel(undefined, undefined, undefined);
        this.ngUnsubscribe = new Subject_1.Subject();
        this.isReady = false;
        this.valueChange = new core_1.EventEmitter();
        this.modelChanged = new Subject_1.Subject();
        this.modelChanged
            .debounceTime(2000) // wait 300ms after the last event before emitting last event
            .distinctUntilKeyChanged('value') // only emit if value is different from previous value
            .subscribe(function (change) {
            if (change.emitValue && _this.isValidAccountingModel()) {
                _this.valueChange.emit(change.value);
            }
        });
    }
    SisPortfolioAccountingComponent.prototype.ngOnInit = function () {
        var _this = this;
        skynet_store_currencies_api_1.currencyStoreManager.selectAll(this.store).takeUntil(this.ngUnsubscribe).subscribe(function (currencies) {
            _this._currencies = currencies.toList().toArray();
            _this.isReady = true;
        });
        this.startValueId = this._fieldName ? this._fieldName + "_valueFrom" : "valueFrom";
        this.endValueId = this._fieldName ? this._fieldName + "_valueTo" : "valueTo";
    };
    SisPortfolioAccountingComponent.prototype.ngOnChanges = function (changes) {
        if (changes.value) {
            this.modelChanged.next(new simple_filter_change_model_1.SimpleFilterChange(changes.value.currentValue, false));
        }
    };
    Object.defineProperty(SisPortfolioAccountingComponent.prototype, "accountingModel", {
        get: function () {
            return this._accountingModel;
        },
        set: function (accountingModel) {
            this._accountingModel = accountingModel;
            this.changedValuesToBeEmitted.to = this.to = accountingModel.to;
            this.changedValuesToBeEmitted.from = this.from = accountingModel.from;
            this.changedValuesToBeEmitted.currencyId = this.currencyId = accountingModel.currencyId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisPortfolioAccountingComponent.prototype, "from", {
        get: function () {
            return this._from;
        },
        set: function (from) {
            this._from = from;
            if (this._from) {
                this.changedValuesToBeEmitted.from = this._from;
            }
            else {
                this.changedValuesToBeEmitted.from = this._from === 0 ? 0 : null; //case when user removes start date filter
            }
            this.validateAccountingValues();
        },
        enumerable: true,
        configurable: true
    });
    SisPortfolioAccountingComponent.prototype.changeValueFrom = function ($event) {
        this._from = $event.target.value;
        if (this._from) {
            this.changedValuesToBeEmitted.from = this._from;
        }
        else {
            this.changedValuesToBeEmitted.from = this._from === 0 ? 0 : null; //case when user removes start date filter
        }
        if (this.isValidAccountingModel()) {
            this.valueChange.emit(this.changedValuesToBeEmitted);
        }
        this.validateAccountingValues();
    };
    SisPortfolioAccountingComponent.prototype.changeValueTo = function ($event) {
        this._to = $event.target.value;
        if (this._to) {
            this.changedValuesToBeEmitted.to = this._to;
        }
        else {
            this.changedValuesToBeEmitted.to = this._to === 0 ? 0 : null; //case when user removes start date filter
        }
        if (this.isValidAccountingModel()) {
            this.valueChange.emit(this.changedValuesToBeEmitted);
        }
        this.validateAccountingValues();
    };
    SisPortfolioAccountingComponent.prototype.onKeyUpFrom = function ($event) {
        this._to = $event.target.value;
        if (this._to) {
            this.changedValuesToBeEmitted.to = this._to;
        }
        else {
            this.changedValuesToBeEmitted.to = this._to === 0 ? 0 : null; //case when user removes start date filter
        }
        this.modelChanged.next(new simple_filter_change_model_1.SimpleFilterChange(this.changedValuesToBeEmitted));
        this.validateAccountingValues();
    };
    SisPortfolioAccountingComponent.prototype.onKeyUpTo = function ($event) {
        this._from = $event.target.value;
        if (this._from) {
            this.changedValuesToBeEmitted.from = this._from;
        }
        else {
            this.changedValuesToBeEmitted.from = this._from === 0 ? 0 : null; //case when user removes start date filter
        }
        this.modelChanged.next(new simple_filter_change_model_1.SimpleFilterChange(this.changedValuesToBeEmitted));
        this.validateAccountingValues();
    };
    Object.defineProperty(SisPortfolioAccountingComponent.prototype, "to", {
        get: function () {
            return this._to;
        },
        set: function (to) {
            this._to = to;
            if (this._to) {
                this.changedValuesToBeEmitted.to = this._to;
            }
            else {
                this.changedValuesToBeEmitted.to = this._to === 0 ? 0 : null; //case when user removes start date filter
            }
            this.validateAccountingValues();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisPortfolioAccountingComponent.prototype, "currencyId", {
        get: function () {
            return this._currencyId;
        },
        set: function (currencyId) {
            this.changedValuesToBeEmitted.currencyId = this._currencyId = currencyId;
        },
        enumerable: true,
        configurable: true
    });
    SisPortfolioAccountingComponent.prototype.changeCurrencyValue = function (currencyId) {
        this.changedValuesToBeEmitted.currencyId = this._currencyId = currencyId;
        if (this.isValidAccountingModel()) {
            this.valueChange.emit(this.changedValuesToBeEmitted);
        }
    };
    Object.defineProperty(SisPortfolioAccountingComponent.prototype, "fieldName", {
        get: function () {
            return this._fieldName;
        },
        set: function (value) {
            this._fieldName = value;
        },
        enumerable: true,
        configurable: true
    });
    SisPortfolioAccountingComponent.prototype.validateAccountingValues = function () {
        if ((this.changedValuesToBeEmitted.from || this.changedValuesToBeEmitted.from === 0) && (this.changedValuesToBeEmitted.to || this.changedValuesToBeEmitted.to === 0)
            && this.changedValuesToBeEmitted.from > this.changedValuesToBeEmitted.to) {
            this.errorMessageKey = this.messageKey;
        }
        else {
            this.errorMessageKey = '';
        }
    };
    SisPortfolioAccountingComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    SisPortfolioAccountingComponent.prototype.isValidAccountingModel = function () {
        return !this.changedValuesToBeEmitted.isEmpty();
    };
    SisPortfolioAccountingComponent.decorators = [
        { type: core_1.Component, args: [{
                    moduleId: module.id + '',
                    selector: 'sis-portfolio-accounting',
                    styles: [require('./sis-portfolio-accounting.component.css')],
                    template: "\n        <div #dataRangeElement *ngIf=\"isReady\" class=\"sis-accounting\">\n            <div fxLayout=\"row\" fxLayoutAlign=\"space-between center\">\n                <div fxFlex=\"33\">\n                    <mat-form-field class=\"sis-form-field\" floatLabel=\"never\" color=\"accent\">\n                        <input matInput [ngModel]=\"from\" (change)=\"changeValueFrom($event)\"\n                               type=\"number\" [id]=\"startValueId\" placeholder=\"From\" step=\"0.01\">\n                    </mat-form-field>\n                </div>\n                <span class=\"sis-accounting__label-divider\">-</span>\n                <div fxFlex=\"33\">\n                    <mat-form-field class=\"sis-form-field\" floatLabel=\"never\" color=\"accent\">\n                        <input matInput [ngModel]=\"to\"\n                               (change)=\"changeValueTo($event)\" type=\"number\" [id]=\"endValueId\" placeholder=\"To\" step=\"0.01\">\n                    </mat-form-field>\n                </div>\n\n                <div fxFlex=\"30\">\n                    <sis-combo-box\n                            [id]=\"currencyFieldId\"\n                            [value]=\"currencyId\"\n                            (valueChange) = changeCurrencyValue($event)\n                            [placeHolder]=\"'de_select_one' | sisTranslateMessage | async\">\n                        <sis-combo-box-items [data]=\"_currencies\" [valueField]=\"'id'\" [nameField]=\"'abbreviation'\">\n                        </sis-combo-box-items>\n                    </sis-combo-box>\n                </div>\n            </div>\n            <sis-error [forControl]=\"dataRangeElement\" [isInput]=\"true\" [id]=\"'selenium-test-status-validation'\"\n                       [errorMessage]=\"errorMessageKey | sisTranslateMessage | async\"></sis-error>\n        </div>"
                },] },
    ];
    /** @nocollapse */
    SisPortfolioAccountingComponent.ctorParameters = function () { return [
        { type: idm_session_data_provider_api_js_1.CurrentLanguageProvider, },
        { type: store_1.Store, },
    ]; };
    SisPortfolioAccountingComponent.propDecorators = {
        "valueChange": [{ type: core_1.Output },],
        "accountingModel": [{ type: core_1.Input },],
        "fieldName": [{ type: core_1.Input },],
    };
    SisPortfolioAccountingComponent = __decorate([
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "<sis-portfolio-accounting></sis-portfolio-accounting>",
        }),
        __metadata("design:paramtypes", [idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            store_1.Store])
    ], SisPortfolioAccountingComponent);
    return SisPortfolioAccountingComponent;
}());
exports.SisPortfolioAccountingComponent = SisPortfolioAccountingComponent;
//# sourceMappingURL=sis-portfolio-accounting.component.js.map